import { render, staticRenderFns } from "./closePermissionRequest.vue?vue&type=template&id=38a2edd5&scoped=true&"
import script from "./closePermissionRequest.vue?vue&type=script&lang=js&"
export * from "./closePermissionRequest.vue?vue&type=script&lang=js&"
import style0 from "./closePermissionRequest.vue?vue&type=style&index=0&id=38a2edd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a2edd5",
  null
  
)

export default component.exports